import "./AmbassadorsPage.css";

import StoryblokClient from "storyblok-js-client";
import { Space, Table, Tag, Button, Tabs } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Modal } from "@tourmalinecore/react-tc-modal";
import ContentCard from "../../../components/ContentCard/ContentCard";
import DefaultCardHeader from "../../../components/DefaultCardHeader/DefaultCardHeader";
import { API_ROOT } from "../../../common/config/config";
import { api } from "../../../common/api/api";
import Submissions from "../../../components/Ambassadors/Submissions/Submissions";
import ApprovedMembers from "../../../components/Ambassadors/ApprovedMembers/ApprovedMembers";
import { Categories } from "../../../common/utils";

const { Column } = Table;

const tabItems = [
  {
    label: "Submissions",
    key: "1",
    children: <Submissions />,
  },
  {
    label: "The Board",
    key: "2",
    children: <ApprovedMembers category={Categories.THE_BOARD_SECTION} />,
  },
  {
    label: "Advisory Board",
    key: "7",
    children: <ApprovedMembers category={Categories.ADVISORY_BOARD} />,
  },
  {
    label: "Operations",
    key: "3",
    children: <ApprovedMembers category={Categories.HEADS_OF_RESEARCH} />,
  },
  {
    label: "Field Research Officers",
    key: "4",
    children: <ApprovedMembers category={Categories.FIELD_RESEARCH_OFFICERS} />,
  },
  {
    label: "Advocates",
    key: "5",
    children: <ApprovedMembers category={Categories.ADVOCATES} />,
  },
  {
    label: "Ambassadors",
    key: "6",
    children: <ApprovedMembers category={Categories.BRAND_AMBASSADORS} />,
  },
];

export default function TablePage() {
  const [refresh, setResfresh] = useState(false);
  const [isDeletionModalVisible, setIsDeletionModalVisible] = useState(false);
  const [deleteAmbassadorId, setDeleteAmbassadorId] = useState(null);
  const [ambassadors, setAmbassadors] = useState([]);
  const [loading, setLoading] = useState([]);
  const [deleting, setDeleting] = useState({
    loading: false,
    _uid: "",
  });

  const history = useHistory();

  const columns = [
    {
      Header: "Photo",
      accessor: "photoUrl",
      width: 100,
      disableFilters: true,
      disableSortBy: true,
      Cell: (row) => {
        console.log(row.data[0].photo.filename);
        return (
          <div className="column__photo" width="60" height="50">
            <img
              src={
                row.data[0].photo.filename ||
                "https://fastorageaccountdev.blob.core.windows.net/faabmassadorsphoto/7ny8E41QGJs.jpg"
              }
              alt=""
              className="photo__src"
            />
          </div>
        );
      },
    },
    {
      Header: "First Name",
      accessor: "firstName",
      disableFilters: true,
      width: 130,
    },
    {
      Header: "Last Name",
      accessor: "lastName",
      disableFilters: true,
      width: 130,
    },
    {
      Header: "Designation",
      accessor: "designation",
      disableFilters: true,
      width: 200,
    },
    {
      Header: "Status",
      accessor: "status",
      disableFilters: true,
      width: 100,
      Cell: (raw) => renderStatus(raw.value),
    },
  ];

  const actions = [
    {
      name: "confirm-ambassador-action",
      show: (row) => !row.original.confirmed,
      renderIcon: () => <FontAwesomeIcon icon={faCheck} />,
      renderText: () => "Confirm",
      onClick: (e, row) => confirmAmbassador(row.original.id),
    },
    {
      name: "edit-ambassador-action",
      show: () => true,
      renderIcon: () => <FontAwesomeIcon icon={faEdit} />,
      renderText: () => "Edit",
      onClick: (e, row) => history.push(`/ambassadors/${row.original.id}`),
    },
    {
      name: "delete-ambassador-action",
      show: () => true,
      renderIcon: () => <FontAwesomeIcon icon={faTrash} />,
      renderText: () => "Delete",
      onClick: (e, row) => {
        setIsDeletionModalVisible(true);
        setDeleteAmbassadorId(row.original.id);
      },
    },
  ];

  const deleteHandler = (record) => {
    const copy = [...ambassadors.body[1].teams[2].members];

    const data = copy.filter((item) => item._uid !== record._uid);
    // setDeleting({
    //   loading: true,
    //   _uid: record._uid,
    // });
  };

  const onChange = (key) => {};

  const editRedirect = (record) => {
    history.push({
      pathname: `/ambassadors/${record._uid}`,
      state: {
        record,
        ambassadors,
      },
    });
  };

  const fetchAmbassadorStory = async () => {
    setLoading(true);
    try {
      // const response = await Storyblok.get("spaces/129638/stories/535348452");
      // const { story } = response.data;
      // console.log(story.content.body[1].teams[2].members);
      // setAmbassadors(story);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchAmbassadorStory();
  }, []);

  return (
    <ContentCard
      isStickyHead
      headerContent={
        <div>
          <DefaultCardHeader>
            <div className="ambassadors-card__header">
              Ambassadors List
              <Link
                to="/ambassadors/create"
                style={{ color: "inherit", textDecoration: "inherit" }}
              >
                <Button>Create</Button>
              </Link>
            </div>
          </DefaultCardHeader>
        </div>
      }
    >
      <div style={{ paddingTop: 4 }}>
        {isDeletionModalVisible && (
          <Modal
            title="Delete ambassador"
            icon={<FontAwesomeIcon icon={faTrash} />}
            content="Are you sure you want to delete the selected entry?"
            overlay
            onClose={() => setIsDeletionModalVisible(false)}
            showApply
            onApply={() => deleteAmbassador(deleteAmbassadorId)}
            applyText="OK"
            showCancel
            onCancel={() => setIsDeletionModalVisible(false)}
          />
        )}

        <Tabs onChange={onChange} type="card" items={tabItems} />

        {/* {!loading && (
          <Table dataSource={[]} bordered>
            <Column
              title="Photo"
              dataIndex="photo"
              key="photo"
              render={(photo) => (
                <div className="column__photo" width="100" height="90">
                  <img
                    src={
                      photo.filename ||
                      "https://fastorageaccountdev.blob.core.windows.net/faabmassadorsphoto/7ny8E41QGJs.jpg"
                    }
                    alt=""
                    className="photo__src"
                  />
                </div>
              )}
            />
            <Column title="First Name" dataIndex="firstName" key="firstName" />
            <Column title="Last Name" dataIndex="lastName" key="lastName" />
            <Column
              title="Designation"
              dataIndex="designation"
              key="designation"
            />
            <Column
              title="Status"
              dataIndex="status"
              key="status"
              render={(status) => {
                let color = "green";
                if (status === "Pending") color = "orange";
                else if (status === "Rejected") color = "red";

                return <Tag color={color}>{status.toUpperCase()}</Tag>;
              }}
            />
            <Column
              title="Action"
              key="action"
              render={(_, record) => {
                console.log(record);
                return (
                  <Space size="middle">
                    <Button
                      type="primary"
                      icon={<EditOutlined />}
                      ghost
                      onClick={() => editRedirect(record)}
                    >
                      Edit
                    </Button>
                    <Button
                      type="primary"
                      icon={<DeleteOutlined />}
                      danger
                      onClick={() => deleteHandler(record)}
                      disabled={
                        deleting.loading && record._uid === deleting._uid
                      }
                      loading={
                        deleting.loading && record._uid === deleting._uid
                      }
                    >
                      Delete
                    </Button>
                  </Space>
                );
              }}
            />
          </Table>
        )} */}
        {/* <ServerTable
          tableId="ambassadors-list-table"
          isStriped
          actions={actions}
          // order={{
          //   id: "orderNumber",
          //   desc: false,
          // }}
          columns={columns}
          apiHostUrl={API_ROOT}
          dataPath="/ambassadors/page"
          requestMethod="GET"
          refresh={refresh}
        /> */}
      </div>
    </ContentCard>
  );

  function renderStatus(isConfirmed) {
    return isConfirmed ? "Confirmed" : "Not confirmed";
  }

  async function confirmAmbassador(id) {
    await api({
      method: "POST",
      url: `/ambassadors/approve/${id}`,
    });

    setResfresh(!refresh);
  }

  async function deleteAmbassador(id) {
    await api({
      method: "DELETE",
      url: `/ambassadors/${id}`,
    });

    setIsDeletionModalVisible(false);
    setResfresh(!refresh);
  }
}
